import type { ClientContext } from '~/services/contextClient';
import type { IntelligentInboxSettingsClientInterface } from './intelligentInboxSettingsClient.types';
import CorporateIntelligentInboxSettingsClient from './corporateIntelligentInboxSettingsClient';

export default class IntelligentInboxSettingsClientFactory {
    static createClient(context: ClientContext): IntelligentInboxSettingsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateIntelligentInboxSettingsClient(context.teamId);
        }

        throw new Error('Intelligent Inbox settings are only available at corporate level');
    }
}
